export default function indexOfRegExp(needle: string, haystack: string, startIndex?: number): number {
  if (startIndex == null) {
    startIndex = 0;
  }
  const re = new RegExp(needle, 'g');
  re.lastIndex = startIndex;
  const match = re.exec(haystack);
  if (match == null) {
    return -1;
  }
  return match.index;
}
